import type { IconDefinition } from '../index.tsx';

export const iconList: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconList',
  icon: [
    16,
    16,
    [],
    '',
    'M3 1H1V3H3V1Z M3 5H1V7H3V5Z M1 9H3V11H1V9Z M3 13H1V15H3V13Z M15 1H5V3H15V1Z M15 5H5V7H15V5Z M5 9H15V11H5V9Z M15 13H5V15H15V13Z',
  ],
};
